<template>
  <div class="view-point">
    <dl>
      <div
        class="viewpoints-img"
        :style="`background: url(${userOfferImageUrlForSp}/ttl_view_point.png) no-repeat center;`"
      />
      <dt :style="`background: url(${userOfferImageUrlForSp}/view_point_line.png) repeat-x bottom;`">
        女の転職！取材レポート
      </dt>
      <dd
        v-if="report.name"
        class="report-title fs12 fb"
        data-test="name"
      >
        取材担当{{ report.name }}より
      </dd>
      <dd
        class="pega-pre-wrap"
        v-text="report.body"
      />
      <template v-if="report.improve">
        <dd
          class="report-title fs12 fb"
          data-test="improve-title"
        >
          この仕事で磨ける経験・能力
        </dd>
        <dd
          class="pega-pre-wrap"
          data-test="improve"
          v-text="report.improve"
        />
      </template>
      <dl
        v-if="interviews.length"
        class="view-msg mt15 pt15 pb15 plr15"
        data-test="interviews"
      >
        <dt
          class="viewpoints-title"
          :style="`background: url(${userOfferImageUrlForSp}/view_point_line.png) repeat-x bottom;`"
        >
          社員の方にインタビューしました
        </dt>
        <template v-for="(interview, i) in interviews">
          <span
            v-if="i"
            :key="`bar-${i}`"
            :data-test="`bar-${i}`"
            class="viewpoints-bar mt15"
          />
          <dt
            v-if="interview.title"
            :key="`title-${i}`"
            :data-test="`title-${i}`"
            class="viewpoints-title-normal mt15 fs12"
          >
            {{ interview.title }}
          </dt>
          <dd :key="`body-${i}`">
            <img
              v-if="interview.photo"
              :src="getPhotoUrl(interview.photo)"
              :data-test="`photo-${i}`"
              class="offer-img-sub-interview image-height-auto mb15"
            >
            <p
              class="pega-pre-wrap"
              :data-test="`body-${i}`"
              v-text="interview.body"
            />
          </dd>
        </template>
      </dl>
    </dl>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/offer/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'

export default {
  mixins: [jobPreviewCommon],
  props: {
    report: {
      type: Object,
      default: () => {}
    },
    interviews: {
      type: Array,
      default: () => []
    }
  }
}
</script>
